export default __webpack_public_path__ + "static/media/github.a229f060.svg";